<form
  class="dlg"
  role="dialog"
  aria-modal="true"
  aria-labelledby="dlg-title"
  [formGroup]="form"
  (ngSubmit)="save()"
>
  <header class="dlg__header">
    <h2 id="dlg-title" class="dlg__title">
      {{ headerTitleKey | translate }}
    </h2>
    <p class="dlg__subtitle">
      {{
        "service_manager.delay.subtitle"
          | translate
            : { default: "Elige quien ha causado el retraso y su motivo." }
      }}
    </p>
  </header>

  <section class="dlg__section">
    <label class="dlg__question">
      {{
        "service_manager.delay.question"
          | translate : { default: "¿Quien ha causado el retraso?" }
      }}
    </label>

    <div class="pill-group" role="radiogroup" aria-label="caused-by">
      <button
        type="button"
        class="pill"
        *ngFor="let opt of options"
        [class.pill--active]="form.value.causedBy === opt.value"
        (click)="form.get('causedBy')!.setValue(opt.value)"
        role="radio"
        [attr.aria-checked]="form.value.causedBy === opt.value"
      >
        <span class="pill__dot" aria-hidden="true"></span>
        <span class="pill__label">{{ opt.labelKey | translate }}</span>
      </button>
    </div>
  </section>

  <section class="dlg__section">
    <label class="dlg__label" for="reason">
      {{ "service_manager.delay.reason" | translate : { default: "Motivo" } }}
    </label>

    <ng-select
      id="reason"
      [items]="reasons"
      bindLabel="labelKey"
      bindValue="code"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'service_manager.delay.reason_placeholder'
          | translate : { default: 'Selecciona el motivo' }
      }}"
      formControlName="reasonCode"
      class="reason-select"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ item.labelKey | translate }}
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        {{ item.labelKey | translate }}
      </ng-template>
    </ng-select>
  </section>

  <footer class="dlg__footer">
    <button type="button" class="btn btn--ghost" (click)="close()">
      {{ "common.actions.close" | translate : { default: "Cerrar" } }}
    </button>

    <button
      type="submit"
      class="btn btn--confirm"
      [disabled]="form.invalid || saving || reasonsLoading"
    >
      <ng-container *ngIf="saving; else saveLbl">
        <span class="spinner"></span>
      </ng-container>
      <ng-template #saveLbl>
        {{ "common.actions.save" | translate : { default: "Guardar" } }}
      </ng-template>
    </button>
  </footer>
</form>
